module.exports = __webpack_public_path__ + "img/1591234327.c48d7865.jpg";